import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { stationMatches } from 'utils/search'
import { images, fallback } from 'images/image-library'
import { ImageAsset } from 'components/common/image-asset'
import { TruncatedText } from 'components/common/truncated-text'
import { ReactComponent as ActiveIcon } from 'images/checkbox/active.svg'
import { ReactComponent as InactiveIcon } from 'images/checkbox/inactive.svg'
import styles from '../StationSelector.module.scss'

const cx = classNames.bind(styles)

const StationList = ({
  stations,
  value,
  search,
  handleDropdownItemClick,
  isHighlighted,
  highlightColour,
  parseSubHeadingText,
  subHeadingIconLeft: SubHeadingIconLeft,
  subHeadingIconHighlighted: SubHeadingIconHighlighted
}) => {
  const filteredStations = search
    ? stations.filter((s) => stationMatches(s.name, search))
    : stations.slice()

  return (
    <>
      {filteredStations.map((station) => {
        const highlighted = isHighlighted ? isHighlighted(station) : false
        const subHeadingText = parseSubHeadingText ? parseSubHeadingText(station) : null

        return (
          <div
            key={station.id}
            className={cx('item', { highlighted })}
            style={highlighted && highlightColour ? { backgroundColor: highlightColour } : undefined}
            onClick={(event) => handleDropdownItemClick(event, station.id)}
            data-testid="item"
          >
            <div className={cx('station-name')}>
              <ImageAsset
                height={20}
                width={20}
                src={images.brandImage(station.brand?.key)}
                alt={`station-cell-brand-${station.brand?.key}`}
                fallbackImage={fallback.defaultBrand}
              />
              <div className={cx('station-name-text')}>
                {subHeadingText && (
                  <div className={cx('sub-heading')}>
                    {SubHeadingIconLeft && <SubHeadingIconLeft className={cx('sub-heading-icon-left')} />}
                    <span>{subHeadingText}</span>
                    {highlighted && SubHeadingIconHighlighted && <SubHeadingIconHighlighted className={cx('sub-heading-icon-highlighted')} />}
                  </div>
                )}
                <TruncatedText as="span">{station.name}</TruncatedText>
              </div>
            </div>
            {value.includes(station.id) ? <ActiveIcon /> : <InactiveIcon />}
          </div>
        )
      })}
    </>
  )
}

StationList.propTypes = {
  stations: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
  handleDropdownItemClick: PropTypes.func.isRequired,
  isHighlighted: PropTypes.func,
  highlightColour: PropTypes.string,
  parseSubHeadingText: PropTypes.func,
  subHeadingIconLeft: PropTypes.elementType,
  subHeadingIconHighlighted: PropTypes.elementType
}

export default StationList
